import { useHttp } from "@/composables/useHttp"

export function useOrderHttp() {
  const http = useHttp()

  async function createOrder(order: any) {
    return (await http.post('/orders', order)).data.data
  }

  async function findByUuid(uuid: string) {
    return (await http.get(`/orders/${uuid}`)).data.data
  }

  async function restore(order: string) {
    return (await http.post(`/orders/${order}/restore`, order)).data.data
  }

  async function fakePayment(order: string, method: string, callbackUrl: string, option: string | null) {
    return (await http.post(`/orders/${order}/payment/integrations/fake`, {
      method,
      callback_url: callbackUrl,
      ...(option !== null && { option }),
    })).data.data.redirect_url as string
  }

  async function molliePayment(order: string, method: string, callbackUrl: string, option: string | null) {
    return (await http.post(`/orders/${order}/payment/integrations/mollie`, {
      method,
      callback_url: callbackUrl,
      ...(option !== null && { option }),
    })).data.data.redirect_url as string
  }

  async function findByReviewToken(token: string) {
    return await http.get(`/orders/by-review-token/${token}`)
  }

  async function createStripePayment(orderId: string) {
    const response = await http.post(`orders/${orderId}/payment/integrations/stripe`)

    return response.data
  }

  return {
    findByUuid,
    findByReviewToken,
    restore,
    fakePayment,
    molliePayment,
    createOrder,
    createStripePayment,
  }
}
